import { Suspense } from 'react'

import { Routes, Route } from 'react-router-dom'

import CircularIndeterminate from './components/CircularIndeterminate'

import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/ko'

import { ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectDisplayMode } from './hooks/themeMode'
import { darkTheme, lightTheme } from './constants/defaultValues'

import RequireAuth from './components/RequireAuth'

import AppLayout from './layouts/AppLayout'

import { LicenseInfo } from '@mui/x-license-pro'

// admin
import Dashboard from './pages/admin/dashboard/Dashboard'
import CmmnCode from './pages/admin/config/cmmnCode/CmmnCode'
// pages

import Login from './pages/user/Login'
import Error404 from 'pages/error/Error404'
import Unauthorized from 'pages/error/Unauthorized'
import Board from 'pages/admin/board/Board'

// social login
import Find from 'pages/user/Find'
import Join from 'pages/user/Join'
import PasswordReset from 'pages/user/PasswordReset'
import User from 'pages/admin/user/User'
import LoginRedirect from 'pages/user/LoginRedirect'
import Qna from 'pages/admin/board/Qna'
import Ask from 'pages/admin/board/Ask'
import Survey from 'pages/admin/survey/Survey'
import Call from 'pages/admin/call/Call'
import Order from 'pages/admin/order/Order'
import Product from 'pages/admin/order/Product'
import SurveyResult from 'pages/admin/survey/SurveyResult'
import Test from 'pages/Test'
import HealthData from 'pages/admin/health/HealthData'
import Message from 'pages/admin/message/Message'
import Group from 'pages/admin/message/Group'
import MessageTemplate from 'pages/admin/message/MessageTemplate'
import Landing from 'pages/Landing'

LicenseInfo.setLicenseKey(`${process.env.REACT_APP_MUIKEY}`)

const ROLES = {
	ROLE_USER: 1,
	ROLE_ADMIN: 2,
	ROLE_SYSTEM: 3,
}

function App() {
	const themeMode = useSelector(selectDisplayMode)

	return (
		<ThemeProvider theme={themeMode.isDarkMode ? darkTheme : lightTheme}>
			<LocalizationProvider
				dateAdapter={AdapterDayjs}
				adapterLocale="ko"
			>
				<Suspense fallback={<CircularIndeterminate />}>
					<Routes>
						<Route
							path="/*"
							element={<Error404 />}
						/>
						<Route
							path="/"
							element={<Landing />}
						/>
						<Route
							path="/unauthorized"
							element={<Unauthorized />}
						/>
						<Route
							path="/user/login"
							element={<Login />}
						/>
						{/* <Route
							path="/user/login"
							element={<Login />}
						/> */}
						<Route
							path="/user/login/redirect"
							element={<LoginRedirect />}
						/>
						<Route
							path="/user/join"
							element={<Join />}
						/>
						<Route
							path="/user/find"
							element={<Find />}
						/>
						<Route
							path="/user/password-reset"
							element={<PasswordReset />}
						/>
						<Route
							path="/admin"
							element={
								<AppLayout>
									<RequireAuth allowedRoles={[ROLES.ROLE_ADMIN, ROLES.ROLE_SYSTEM]} />
								</AppLayout>
							}
						>
							<Route
								path="dashboard"
								element={<Dashboard />}
							/>
							<Route
								path="config/cmmnCode"
								element={<CmmnCode />}
							/>
							<Route
								path="notice"
								element={<Board />}
							/>
							<Route
								path="user"
								element={<User />}
							/>
							<Route
								path="qna"
								element={<Qna />}
							/>
							<Route
								path="ask"
								element={<Ask />}
							/>
							<Route
								path="survey"
								element={<Survey />}
							/>
							<Route
								path="survey/result"
								element={<SurveyResult />}
							/>
							<Route
								path="call"
								element={<Call />}
							/>
							<Route
								path="order"
								element={<Order />}
							/>
							<Route
								path="product"
								element={<Product />}
							/>
							<Route
								path="health_data"
								element={<HealthData />}
							/>
							<Route
								path="message"
								element={<Message />}
							/>
							<Route
								path="message/group"
								element={<Group />}
							/>
							<Route
								path="message/template"
								element={<MessageTemplate />}
							/>
						</Route>
					</Routes>
				</Suspense>
			</LocalizationProvider>
		</ThemeProvider>
	)
}

export default App
